import { c as _c } from "react/compiler-runtime";
import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@repo/blacksmith-ui/cn";

/** Horizontal padding for each header layout. */
const INSET_CLASS = {
  none: "",
  /** Full-width page headers (PageHeader, Settings, Usage). */
  page: "px-4 md:px-8",
  /** Pages laid out in a `px-6` content column (repositories, Monitors). */
  content: "px-6",
  /** Codesmith session/workspace panes. */
  pane: "px-4",
  /** Codesmith new-session canvas. */
  canvas: "px-3 md:px-6",
  /** Contextual sidebars: title flush with the nav, icon buttons flush right. */
  sidebar: "pl-4 pr-2"
} as const;
const HEIGHT_CLASS = {
  /** Fixed header height; content must fit (sidebars, panes). */
  fixed: "h-app-header",
  /** Minimum header height, growing when content wraps (page headers). */
  min: "min-h-app-header",
  /** Minimum header height from md up; on narrow viewports, `py-4`
   * accommodates stacked breadcrumbs and controls. */
  "min-md": "py-4 max-md:min-h-0 md:min-h-app-header md:py-0"
} as const;
interface AppHeaderBarProps extends ComponentPropsWithoutRef<"div"> {
  as?: "div" | "header";
  inset?: keyof typeof INSET_CLASS;
  height?: keyof typeof HEIGHT_CLASS;
}

/** Shares `--spacing-app-header` across page, sidebar and pane headers. */
export function AppHeaderBar(t0) {
  const $ = _c(14);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      as: t1,
      inset: t2,
      height: t3,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const Tag = t1 === undefined ? "div" : t1;
  const inset = t2 === undefined ? "none" : t2;
  const height = t3 === undefined ? "fixed" : t3;
  const t4 = HEIGHT_CLASS[height];
  const t5 = INSET_CLASS[inset];
  let t6;
  if ($[6] !== className || $[7] !== t4 || $[8] !== t5) {
    t6 = cn("flex shrink-0 items-center", t4, t5, className);
    $[6] = className;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== Tag || $[11] !== props || $[12] !== t6) {
    t7 = <Tag className={t6} {...props} />;
    $[10] = Tag;
    $[11] = props;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}